import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';

const CaretIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 256 256" className="inline-block align-middle ml-2 transition-transform group-open:rotate-180" aria-hidden="true">
    <path fill="currentColor" d="M213.66 101.66 128 187.31 42.34 101.66a8 8 0 0 1 11.32-11.32L128 164.69l74.34-74.35a8 8 0 0 1 11.32 11.32Z" />
  </svg>
);

const Collapsible = ({ blok }) => {
  const startCollapsed = blok.default_collapsed !== false;
  const expandedLabel = blok.expanded_label || blok.collapsed_label;
  const items = blok.body || [];
  const isButton = blok.toggle_style === 'button';

  return (
    <details {...storyblokEditable(blok)} open={!startCollapsed} className="w-full group">
      {/* The button style copies the old site's "See more features" toggle
          (btn-small on white with a 1px black border). */}
      <summary
        className={
          isButton
            ? 'list-none cursor-pointer w-fit mx-auto group-open:mb-6 flex items-center px-[30px] py-[10px] rounded-full border border-black bg-white text-16 transition-transform hover:scale-105'
            : 'list-none cursor-pointer text-center text-20 sm:text-24 group-open:pb-14 hover:opacity-80 transition-opacity'
        }
      >
        <strong className="group-open:hidden">{blok.collapsed_label}</strong>
        <strong className="hidden group-open:inline">{expandedLabel}</strong>
        <CaretIcon />
      </summary>
      <div>
        {items.map((nested) => (
          <StoryblokServerComponent blok={nested} key={nested._uid} />
        ))}
      </div>
    </details>
  );
};

export default Collapsible;
